<template>
	<div style="padding: 10px 10px 10px 0;">
		<el-button type="primary" @click="goAdd" style="margin-bottom: 10px;"
		v-hasPermi="['apartment:fwxm:add']">新增</el-button>
		<el-table :data="data" style="width: 100%" border>
			<el-table-column prop="name" label="服务项目"></el-table-column>
			<el-table-column prop="price" label="服务费用(元)"></el-table-column>
			<el-table-column prop="createTime" label="创建时间">
				<template slot-scope="{row}">
					{{ setTime(row.createTime) }}
				</template>
			</el-table-column>
			<el-table-column prop="date" label="操作" >
				<template slot-scope="{row}" >
					<el-button v-hasPermi="['apartment:fwxm:edit']" type="text" @click="chaRow(row)">修改</el-button>
					<el-button v-hasPermi="['apartment:fwxm:del']" type="text" @click="delRow(row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
			:page-sizes="[10, 20, 30, 50]" :page-size="formInlie.pageSize"
			layout="total, sizes, prev, pager, next, jumper" :total="totalNum">
		</el-pagination>
		<el-dialog :title="title" :visible.sync="isShow" width="30%">
			<el-form :model="formData" ref="formData" :rules="rules">
				<el-form-item prop="name" label="服务项目">
					<el-input placeholder="请输入服务项目" v-model="formData.name"></el-input>
				</el-form-item>
				<el-form-item prop="price" label="服务费用(元)">
					<el-input placeholder="请输入服务费用" type="text" @input="(v) => (formData.price = v.replace(/[^\d.]/g, ''))"
						v-model="formData.price"></el-input>
				</el-form-item>
				<el-form-item prop="describes" label="服务描述">
					<el-input placeholder="请输入服务描述" v-model="formData.describes"></el-input>
				</el-form-item>
				<el-form-item prop="type" label="服务类型">
					<el-select v-model="formData.type">
						<el-option label="普通" value="普通"></el-option>
						<el-option label="特殊" value="特殊"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="isShow = false">取 消</el-button>
				<el-button type="primary" @click="confirmClick">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
export default {
	data() {
		return {
			data: [],
			title: '新增',
			isShow: false,
			formInlie: {
				name: null,
				currentPage: 1,
				pageSize: 10
			},
			totalNum: null,
			formData: {
				name: null,
				price: null,
				type: null,
				describes: null
			},
			oldForm: {},
			rules: {
				name: [{
					required: true,
					message: '服务项目不能为空',
					trigger: ["blur", "change"]

				}],
				price: [{
					required: true,
					message: '服务费用不能为空',
					trigger: ["blur", "change"]

				}],
				describes: [{
					required: true,
					message: '服务描述不能为空',
					trigger: ["blur", "change"]

				}],
				type: [{
					required: true,
					message: '服务类型不能为空',
					trigger: ["blur", "change"]

				}]
			}
		}
	},
	methods: {
		handleCurrentChange(val) {
			this.formInlie.currentPage = val
			this.getAll()
		},
		handleSizeChange(val) {
			this.formInlie.pageSize = val
			this.getAll()
		},
		goAdd() {
			this.isShow = true
			this.title = '新增'
			this.formData = JSON.parse(JSON.stringify(this.oldForm))
		},
		chaRow(val) {
			this.isShow = true
			this.title = '修改'
			this.formData = {
				...val
			}
		},
		delRow(val) {
			this.$confirm('此操作将永久删除该成员, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'error'
			}).then(() => {
				this.$http.get(`/api/bdServiceProject/deleteServiceProject?id=${val.id}`).then(res => {
					if (res.data.code == 0) {
						this.$message.success(res.data.message)
						this.getAll();
					} else {
						this.$message.error(res.data.message)
					}
				})
			}).catch(() => {
				this.$message({
					type: 'warning',
					message: '已取消删除'
				});
			});
		},
		confirmClick() {
			this.$refs.formData.validate((valid) => {
				if (valid) {
					console.log(this.title)
					var url = "/api/bdServiceProject/addServiceProject"
					if (this.title == '修改') {
						url = "/api/bdServiceProject/updateServiceProject"
					}
					this.$http.post(url, {
						...this.formData
					}).then(res => {
						console.log(res)
						if (res.data.code == 0) {
							this.$message.success(res.data.message)
							this.isShow = false
							this.getAll()
						} else {
							this.$message.error(res.data.message)
						}
					})
				} else {
					return;
				}

			})
		},
		getAll() {
			this.$http.post("/api/bdServiceProject/queryServiceProject", {
				...this.formInlie
			}).then(res => {
				this.data = res.data.data.items
				this.totalNum=res.data.data.totalNum
				console.log(res)
			})
		}
	},
	mounted() {
		this.getAll()
		this.oldForm = JSON.parse(JSON.stringify(this.formData))
	}
}
</script>

<style scoped="scoped">

</style>
